import { Component, OnDestroy, OnInit, TemplateRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormBuilder,FormGroup } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DataSource } from '@angular/cdk/collections';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { fuseAnimations } from '@fuse/animations';
import { FuseConfirmDialogComponent } from '@fuse/components/confirm-dialog/confirm-dialog.component';

import { MatSnackBar } from "@angular/material/snack-bar";

///IDIOMAS
import { lang_certificar } from 'app/idiomas/i18n/certificar/certificar.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';

//SERVICE
import { DemographicService } from "../../services/demographics.service";

@Component({
    selector     : 'demographic',
    templateUrl  : './demographic.component.html',
    styleUrls    : ['./demographic.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class DemographicComponent {

  centered = false;
  disabled = false;
  unbounded = false;
  banderaSelect: boolean = false;
  preguntas: any;

  radius: number;
  color: string;

  user: FormGroup;
  password: FormGroup;
  RESPONSE: FormGroup;
  RESPONSE2: FormGroup;
  RESPONSE3: FormGroup;
  LEVEL: FormGroup;

  constructor(private _formBuilder: FormBuilder,
              private demographicService: DemographicService,
              public snackBar: MatSnackBar,
              private _fuseTranslationLoaderService: FuseTranslationLoaderService) {

      lang_certificar.forEach((locale) => {
          this._fuseTranslationLoaderService.loadTranslations(locale);
      });

  }

  ngOnInit() {
    this.user = this._formBuilder.group({
      //firstCtrl: ['', Validators.required]
    });
    this.password = this._formBuilder.group({
      //secondCtrl: ['', Validators.required]
    });
    this.RESPONSE = this._formBuilder.group({
      //thirdCtrl: ['', Validators.required]
    });
    this.RESPONSE2 = this._formBuilder.group({
      //fourthCtrl: ['', Validators.required]
    });
    this.RESPONSE3 = this._formBuilder.group({
      //fourthCtrl: ['', Validators.required]
    });
    this.LEVEL = this._formBuilder.group({
      //fourthCtrl: ['', Validators.required]
    });

    this.check();
    this.getBanderaDemograficos();

  }

  public check(){
    let data = {
      fechaCertificar: localStorage.getItem('fechaProducto')
    };

    this.demographicService.getQuestions(data)
    .subscribe(response => {

      console.log(response);

      if(response['message'] == 'Success'){
        if(response['demograficos'].length > 0){
            this.preguntas = response['demograficos'];
        }
      }
      /*
      if(response['message'] == 'Success'){
        if(response['demograficos'].length > 0){
            this.preguntas = response['demograficos'];
        }else{
            this.getDemo();
        }

      }*/

    }, error => {
      console.log("error", error);
    });
  }

    public getDemo(){
      this.demographicService.getDemographics()
      .subscribe(response => {
        this.preguntas = response['demograficosMostrar']['preguntas'];

        this.insertDemo();

      }, error => {
        console.log("error", error);
      });
    }

    public insertDemo(){

      for (let i = 0; i < this.preguntas.length; i++) {
        let value = this.preguntas[i]
        let data = {
          fechaCertificar: localStorage.getItem('fechaProducto'),
          preguntaDemografico: value.preguntaDemografico,
          orden: i,
          clave: value.clave
        };


        this.demographicService.saveDemographic(data)
        .subscribe(response => {
          if(response['message'] == 'Success'){
              this.insertOpciones(value.opciones,response['demografico']['_id']);
          }

        }, error => {
          console.log("error", error);
        });

      }
      let data = {
        fechaCertificar: localStorage.getItem('fechaProducto')
      };

      this.demographicService.getQuestions(data)
      .subscribe(response => {
        if(response['message'] == 'Success'){
          if(response['demograficos'].length > 0){
              this.preguntas = response['demograficos'];
          }
        }
      }, error => {
        console.log("error", error);
      });
    }

    public insertOpciones(opciones,id){

      for (let i = 0; i < opciones.length; i++) {

        let data = {
          demograficoId: id,
          textoOpcion: opciones[i].textoOpcion,
          orden: i,
          fechaCertificar: localStorage.getItem('fechaProducto')
        };


        this.demographicService.saveDemographicOption(data)
        .subscribe(response => {
          if(response['message'] == 'success'){
            //INSERTO CORRECTAMENTE LAS OPCIONES DE RESPUESTA
          }
        }, error => {
          console.log("error", error);
        });

      }
    }


    public onBlurPregunta(event,pregunta){
      if(event.target.value.length > 0){
        let data = {
            fechaCertificar: localStorage.getItem('fechaProducto'),
            demograficoId: pregunta._id,
            preguntaDemografico: event.target.value
        };

        this.updateData(data,'Question updated successfully.');
      }else{
        this.openErrorSnackBar('Error, insert a valid question','OK');
      }

    }

    public onBlurRespuesta(event,opcion,id){
      if(event.target.value.length > 0){
        let data = {
            fechaCertificar: localStorage.getItem('fechaProducto'),
            demograficoId: id,
            opcionId: opcion._id,
            textoOpcion: event.target.value
        };

        this.updateData(data,'Response updated successfully.');
      }else{
        this.openErrorSnackBar('Error, insert a valid response text','OK');
      }
    }

    public drop(event){
      console.log(event);
    }

    public updateData(data,mensaje){

      this.demographicService.updateDemographicData(data)
        .subscribe(response => {
          //console.log(response);
          if(response['message'] == 'Success'){
            //INSERTO CORRECTAMENTE LAS OPCIONES DE RESPUESTA
            this.openSuccessSnackBar(mensaje,'OK');
          }
        }, error => {
          console.log("error", error);
        });
    }

    openErrorSnackBar(message: string, action: string) {
        this.snackBar.open(message, action, {
           duration: 15000,
           verticalPosition: 'bottom',
           panelClass: ['background-red']
        });
     }


     openSuccessSnackBar(message: string, action: string) {
        this.snackBar.open(message, action, {
           duration: 15000,
           verticalPosition: 'top',
           panelClass: ['background-success']
        });
     }

  public setBanderaDemograficos(index){
    let data = {
      fechaCertificar: localStorage.getItem('fechaProducto'),
      bandera: index,
      productoId: localStorage.getItem('productoID')
    }

    this.demographicService.setBanderaDemograficos(data)
      .subscribe(response => {
        if(response['message'] == 'Success'){
          this.guardarDemograficos();
          this.banderaSelect = true;
        }else{
          this.openErrorSnackBar('Error, please try again.','OK');
        }
        //console.log(response);

      }, error => {
        console.log("error", error);
      });
  }

  public guardarDemograficos(){
    let data = {
      fechaCertificar: localStorage.getItem('fechaProducto'),
      productoId: localStorage.getItem('productoID')
    }
    console.log(data);
    this.demographicService.guardarDemograficos(data)
      .subscribe(response => {

        if(response['message'] == 'Success'){
          if(response['demograficos'].length > 0){
              this.preguntas = response['demograficos'];
          }
        }

      }, error => {
        console.log("error", error);
      });
  }

  public getBanderaDemograficos(){
    let data = {
      fechaCertificar: localStorage.getItem('fechaProducto')
    }

    this.demographicService.getBanderaDemograficos(data)
      .subscribe(response => {

        console.log(response);
        console.log(response['bandera']);

        if(response['message'] == 'Success'){
          console.log('ENTRO 1');
          if(response['bandera'] == 0 || response['bandera'] == 1){
            console.log('ENTRO 2');
              this.banderaSelect = true;
              console.log(this.banderaSelect);
          }
        }

      }, error => {
        console.log("error", error);
      });
  }

}
